var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "cp-news-hub-featured-article",
      attrs: { href: this.featuredArticle.url }
    },
    [
      _c("div", { staticClass: "cp-news-hub-featured-article-img-container" }, [
        _c("img", {
          staticClass: "cp-news-hub-featured-article-img",
          attrs: { src: this.GetImageCropper(this.featuredArticle.imageUrl) }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cp-news-hub-featured-article-content-container" },
        [
          _c(
            "div",
            { staticClass: "cp-news-hub-featured-article-content-date" },
            [
              _vm._v(
                "\n            " +
                  _vm._s(this.FormatDate(this.featuredArticle.publishDate)) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cp-news-hub-featured-article-content" }, [
            _c("h2", { staticClass: "featured-article-title" }, [
              _vm._v(_vm._s(this.featuredArticle.title))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "featured-article-author" }, [
              _vm._v(_vm._s(this.featuredArticle.author))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cp-news-hub-featured-article-content-description" },
            [
              _c("p", { staticClass: "featured-article-description" }, [
                _vm._v(_vm._s(this.featuredArticle.description))
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }